import React, { useState } from 'react';
import StudentList from './StudentList';
import Discipline from './Discipline';
import StudentTransfers from './StudentTransfers';

const StudentsModule = () => {
  const [view, setView] = useState('list');
  return (
    <div>
      <div className="d-flex gap-2 mb-4">
        {[
          ['list', <>
            <i className="lni lni-graduation-cap-1 fs-4 lh-0"></i>
            Students Details
          </>],

          ['discipline', <>
            <i className="bi bi-patch-exclamation fs-5 lh-0"></i>
            Discipline
          </>],

          ['promotions', <>
            <i className="lni lni-angle-double-up fs-4 lh-0"></i>
            Promotions
          </>],

          ['transfers', <>
            <i className="lni lni-refresh-user-1 fs-4 lh-0"></i>
            Transfers
          </>]

        ].map(([k, l]) => (
          <button
            key={k}
            className={`btn ${view === k ? 'btn-primary page-btn' : 'btn-outline-secondary page-btn'}`}
            onClick={() => setView(k)}
          >
            {l}
          </button>
        ))}
      </div>
      {view === 'list' && <StudentList />}
      {view === 'discipline' && (
        <>        
          <Discipline/>          
        </>
      )}
      {view === 'promotions' && (
         <>
        <div className="card"><div className="card-body">
          promotions
          </div></div>
        </>
      ) }
      {view === 'transfers' && (
         <>
          <StudentTransfers/>
        </>
      ) }


      {/* {view !== 'list' && (
        <div className="card"><div className="card-body">
          <div className="empty-state">
            <div className="empty-icon">
              {view === 'discipline' ? '⚠️' : view === 'promotions' ? '⬆️' : '🔄'}
              </div>
            <h5>{view.charAt(0).toUpperCase() + view.slice(1)} Management</h5>
            <p>Manage student {view} records here.</p>
          </div>
        </div></div>
      )} */}
    </div>
  );
};
export default StudentsModule;
